// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CountryCount } from './countryCount.zod.ts';

export const CatalogCard = zod.object({
  "by_country": zod.array(CountryCount),
  "by_kind": zod.record(zod.string(), zod.int()),
  "by_status": zod.record(zod.string(), zod.int()),
  "stale": zod.int(),
  "total": zod.int()
});

export type CatalogCard = zod.input<typeof CatalogCard>;
export type CatalogCardOutput = zod.output<typeof CatalogCard>;
